import React, { useContext, useState, useEffect } from 'react';
import styles from './styles.module.scss';
// import Form from '../Form';
import AppFormInput from '../AppFormInput';
// import Api from '@/api';
import Api from '../../api';
// import CheckEmailValidation from '@/functions/CheckEmailValidation';
// import CheckNumericType from '@/functions/CheckNumericType';
// import AppImage from '../AppImage';
import warning from '../../../../assets/imgs/login/warning.svg';
import CheckNumericType from '../../functions/CheckNumeric';
import CheckEmailValidation from '../../functions/CheckEmailValidation';
import { AdminContext } from '../../context/AdminContext';
import Form from '../Form';
import findCountryCode from '../../functions/findCountryCode';
import countriesInfo from '../../objects/countryCodes.json';
// import CheckNumericType from 'renderer/functions/CheckNumeric';
// import CheckEmailValidation from 'renderer/functions/CheckEmailValidation';

// import AppImage from '../AppImage';

const ForgetPasswordMobile = ({
  setLevel1,
  setLevel2,
  newuser,
  setNewUser,
  setLoginModal,
}) => {
  const [user, setUser] = useState(newuser);
  const [showErrorMobile, setShowErrorMobile] = useState(false);
  const [serverError, setServerError] = useState('');
  const [pressEnter, setPressEnter] = useState(false);
  const [loading, setLoading] = useState(false);
  const { content, countries, direction } = useContext(AdminContext);
  const [dial_code, setDial_code] = useState('98');
  const [country, setCountry] = useState();
  // const [countries, setCountries] = useState(
  //   countriesInfo.map((v, i) => {
  //     return { ...v, id: i };
  //   })
  // );

  const [showErrorCode, setShowErrorCode] = useState(false);

  const changeUserMobile = (e) => {
    setUser({ ...newuser, mobile: e.target.value.replace(/^0/, '') });
    setServerError('');
    setShowErrorMobile(false);
    setPressEnter(false);
  };
  const changeUserCode = (e) => {
    // setDial_code( e.target.value);
    let value = e.target.value.replace(/\+/g, '');
    if (
      (CheckNumericType(value) == true || value?.trim()?.length == 0) &&
      value?.trim()?.length < 4
    ) {
      setDial_code(value);
      setServerError('');
      setShowErrorCode(false);
      setNewUser({
        ...newuser,
        countryCode: e.target.value.replace(/\+/g, ''),
      });
    }
  };
  const checkMobileCode = (e) => {
    // if (dial_code != '98' && dial_code != '1') {
    // let index = countries?.findIndex(
    //   (x) => x.dial_code?.replace('+', '') == dial_code
    // );
    let index = countries?.findIndex(
      (x) => x.dial_code?.replace('+', '') == dial_code
    );
    if (dial_code?.trim()?.length == 0 || index == -1) {
      setShowErrorCode(true);
      e.preventDefault();
      return;
    }
    console.log('err==', index, countries, dial_code);
    if (index == -1) {
      setShowErrorCode(true);
      return true;
    } else {
      setShowErrorCode(false);
      return false;
    }
  };

  const submitFormFunction = (e) => {
    let index = countries?.findIndex(
      (x) => x.dial_code?.replace('+', '') == dial_code
    );
    if (dial_code?.trim()?.length == 0 || index == -1) {
      setShowErrorCode(true);
      if (user?.mobile?.trim()?.length == 0) {
        setShowErrorMobile(true);
      }
      e.preventDefault();
      return;
    }
    e.preventDefault();
    if (pressEnter == false) {
      setPressEnter(true);
      let check;
      if (CheckNumericType(user.mobile) == true) {
        check = CheckNumericType(user.mobile);
      } else {
        check = CheckEmailValidation(user.mobile);
      }
      // if (check == false && checkMobileCode() == true) {
      if (
        (check == false && checkMobileCode() == true) ||
        user?.mobile?.trim()?.length == 0
      ) {
        setShowErrorMobile(true);
      } else {
        setShowErrorMobile(false);
        setLoading(true);
        Api.userSendForgetCode({
          username: `${user.mobile}`,
          countryCode: '+' + dial_code,
        })
          .then((res) => {
            setNewUser({ ...newuser, mobile: user.mobile });
            setLevel1(false);
            setLevel2(true);
            setLoading(false);
            setPressEnter(false);
          })
          .catch((err) => {
            setServerError(err?.response?.data?.message);
            setLoading(false);
            setPressEnter(false);
          });
      }
    }
  };

  const checkMobileNumber = () => {
    let check;
    if (CheckNumericType(user.mobile) == true) {
      check = CheckNumericType(user.mobile);
    } else {
      check = CheckEmailValidation(user.mobile);
    }
    if (check == false) {
      setShowErrorMobile(true);
    }
  };
  const goToLoginFunction = () => {
    setLoginModal();
  };

  const findLocation = () => {
    fetch('http://ip-api.com/json')
      // fetch('http://208.95.112.1/json')
      // fetch('https://api.ochatt.com/api/v0/ip-get/list')
      .then((res) => res.json())
      .then((response) => {
        console.log('Country: ', response.country, response);
        setCountry(response);
      })
      .catch((data, status) => {
        console.log('Request failed');
      });
  };
  useEffect(() => {
    findLocation();
  }, []);
  useEffect(() => {
    if (country?.countryCode) {
      setDial_code(
        findCountryCode(country?.countryCode, countries) != -1 &&
          findCountryCode(country?.countryCode, countries) != null
          ? findCountryCode(country?.countryCode, countries)
          : '98'
      );
      setNewUser({
        ...newuser,
        countryCode:
          findCountryCode(country?.countryCode, countries) != -1 &&
          findCountryCode(country?.countryCode, countries) != null
            ? findCountryCode(country?.countryCode, countries)
            : '98',
      });
    }
  }, [country]);

  return (
    <div className={`${styles.container}`}>
      {serverError !== '' && (
        <div className={styles.serverError}>
          {/* <AppImage
            src={warning}
            alt="warning"
            width={20}
            height={20}
            // containerclassName="flex flex-row justify-center items-center"
          /> */}
          <span>{serverError}</span>
        </div>
      )}
      <p className={styles.title}>{content?.forgetPassword?.mobile?.title}</p>
      <p className={styles.text}>
        {content?.forgetPassword?.mobile?.description}
      </p>
      <Form
        onSubmit={submitFormFunction}
        extraClassName="h-[180px] w-full"
        extraStyleButton={{ marginBottom: '0' }}
        user={user}
        buttonText={content?.forgetPassword?.mobile?.button}
        loadingU={loading}
        extraButtonClass={styles.formButton}
      >
        <div
          className={`flex flex-row justify-between items-center w-full h-auto ltr`}
        >
          <span style={{ marginTop: 'auto', padding: '0.5em 0' }}>+</span>
          <AppFormInput
            targetType="num"
            onChange={changeUserCode}
            // inputStyle={styles.inputStyle}
            showError={showErrorCode}
            // showTitle={showTitle}
            onBlur={checkMobileCode}
            title={`${content?.countryCode?.code}`}
            // error={'note supported'}
            // placeholder={content?.personalInfoModal?.placeholder}
            placeholder={`${content?.countryCode?.placeholder}`}
            // wrapperStyle={styles.wrapper}
            wrapperStyle={`${styles.wrapper} borderBottom`}
            className={styles.inputContainerCode}
            value={dial_code}
          />
          <AppFormInput
            targetType="num"
            // type='number'
            placeholder={content?.forgetPassword?.mobile?.input?.placeholder}
            onChange={changeUserMobile}
            inputWidth="420px"
            inputStyle={styles.inputStyle}
            showError={showErrorMobile}
            title={content?.forgetPassword?.mobile?.input?.title}
            // error={content?.forgetPassword?.mobile?.input?.error}
            onBlur={checkMobileNumber}
            wrapperStyle={`${styles.wrapper} borderBottom`}
            className={`${styles.inputContainerMobile} ${direction}`}
            value={user?.mobile}
          />
        </div>
        {showErrorCode && (
          <p
            className={`inputError mb-5px`}
          >{`${content?.countryCode?.error}`}</p>
        )}
        {showErrorMobile && (
          <p className={`inputError mb-5px`}>
            {content?.forgetPassword?.mobile?.input?.error}
          </p>
        )}
      </Form>
    </div>
  );
};

export default ForgetPasswordMobile;
